import { render } from "./11Fast.vue?vue&type=template&id=66ca7c28&scoped=true"
const script = {}

import "./11Fast.vue?vue&type=style&index=0&id=66ca7c28&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ca7c28"]])

export default __exports__